<script>
import Header from '@/components/app/mobile/Header'
import Panel from '@/components/app/mobile/Panel'
import Features from '@/components/app/mobile/Features'
import FlightSharing from '@/components/app/shared/flight-sharing/FlightSharing'
import Footer from '@/components/app/mobile/Footer'

export default {
  components: { Header, Panel, Features, FlightSharing, Footer },
}
</script>

<template>
	<div class="flex flex-col items-center">
		<Header class="self-stretch" />
		<Panel />
		<Features />
		<FlightSharing />
		<Footer />
	</div>
</template>
